import Swiper from "swiper";
import {Navigation, Autoplay, EffectFade} from "swiper/modules";

export default class HeaderLocations {
    constructor() {
        const $sections = document.querySelectorAll('section.header-locations');

        $sections.forEach($section => {
            const swiper = new Swiper($section.querySelector('.swiper'), {
                modules: [Navigation, Autoplay, EffectFade],
                navigation: {
                    disabledClass: 'swiper-button-disabled !opacity-0',
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                centeredSlides: true,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
            });
        });
    }
}

new HeaderLocations();